// extracted by mini-css-extract-plugin
var _1 = "ThreadVersionChangeCard-module__animateUploadProgressBarWidth--GE233";
var _2 = "ThreadVersionChangeCard-module__animatedBackground--o4pf_";
var _3 = "ThreadVersionChangeCard-module__content--ibqEd";
var _4 = "ThreadVersionChangeCard-module__contextContainer--tQIZI";
var _5 = "ThreadVersionChangeCard-module__focused--hpbBa";
var _6 = "ThreadVersionChangeCard-module__footer--FkXls";
var _7 = "ThreadVersionChangeCard-module__footerText--wf4yY";
var _8 = "ThreadVersionChangeCard-module__footerTextContainer--ItEvN";
var _9 = "ThreadVersionChangeCard-module__hasAbsoluteEndQuote--m5CTZ";
var _a = "ThreadVersionChangeCard-module__newCommentsText--xGli4";
var _b = "ThreadVersionChangeCard-module__resolved--WLfGv";
var _c = "ThreadVersionChangeCard-module__unresolveButton--Y6nnK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "contextContainer", _5 as "focused", _6 as "footer", _7 as "footerText", _8 as "footerTextContainer", _9 as "hasAbsoluteEndQuote", _a as "newCommentsText", _b as "resolved", _c as "unresolveButton" }
